<template>
  <div>
    <label>{{ $t('Per page') }}</label>
    <v-select
      v-model="perPage"
      :options="perPageOptions"
      :clearable="false"
      :disabled="total < perPage"
      class="per-page-selector d-inline-block ml-50 mr-1"
    />
  </div>

</template>

<script>
import vSelect from 'vue-select'

export default {
  name: 'ListPerPage',
  components: {
    vSelect,
  },
  props: {
    total: {
      type: Number,
      default: () => 1,
    },
    currentPerPage: {
      type: Number,
      default: () => 25,
    },
  },
  data() {
    return {
      perPage: 25,
      perPageOptions: [25, 50, 75, 100, 150, 200, 300, 500, 1000],
    }
  },
  watch: {
    perPage: 'changePerPage',
    currentPerPage: 'setPerPage',
  },
  created() {
    this.setPerPage()
  },
  methods: {
    changePerPage(perPage) {
      this.perPage = perPage
      this.$router.replace({
        path: this.$route.path,
        hash: this.$route.hash,
        query: { ...this.$route.query, per_page: perPage },
      })
      return this.$emit('onChangePerPage', perPage)
    },
    setPerPage() {
      this.perPage = this.currentPerPage
    },
  },
}
</script>

<style scoped>

</style>
